/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const BalanceTransactionType = {
  GiftCardPurchase: "GIFT_CARD_PURCHASE",
  GiftCardLoadImport: "GIFT_CARD_LOAD_IMPORT",
  GiftCardLoadInitial: "GIFT_CARD_LOAD_INITIAL",
  GiftCardLoad: "GIFT_CARD_LOAD",
  AddManual: "ADD_MANUAL",
  RemoveManual: "REMOVE_MANUAL",
  Refund: "REFUND",
} as const;

export type BalanceTransactionType =
  (typeof BalanceTransactionType)[keyof typeof BalanceTransactionType];

export type BalanceTransactionTypeEnumType = typeof BalanceTransactionType;
export type BalanceTransactionTypeOptional = BalanceTransactionType;
export type BalanceTransactionTypeTrackedI = BalanceTransactionType;
export type BalanceTransactionTypeTracked = BalanceTransactionType;
export type BalanceTransactionTypeMetaI = EnumMetaType<
  BalanceTransactionTypeEnumType,
  BalanceTransactionType
>;
export const BalanceTransactionTypeMeta = typeMetaEnum<
  BalanceTransactionTypeEnumType,
  BalanceTransactionType
>("BalanceTransactionType", BalanceTransactionType);
export function transformDatesBalanceTransactionType(
  model: BalanceTransactionType,
) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
